import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { carrelloCount } from '../hooks/carrelloStorage';

export default function CarrelloFab() {
  const [count, setCount] = useState(carrelloCount());

  useEffect(() => {
    const refresh = () => setCount(carrelloCount());
    window.addEventListener('carrello-updated', refresh);
    window.addEventListener('storage', refresh);
    return () => {
      window.removeEventListener('carrello-updated', refresh);
      window.removeEventListener('storage', refresh);
    };
  }, []);

  if (count === 0) return null;

  return (
    <Link
      to="/carrello"
      className="fixed bottom-6 right-6 z-40 bg-[#c78244] text-white rounded-full shadow-lg px-5 py-3 font-semibold text-sm hover:opacity-90"
      aria-label="Vai al carrello"
    >
      🛒 Carrello ({count})
    </Link>
  );
}
